import React, { useState, useCallback, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { nFormatter, getProfileTypeFromRole } from "../../../shared/utils/function.js";
import {
  ROLE,
  OFFER_TYPE,
  PROMOTION_DISCOUNT_TYPE
} from "../../../shared/constants/common.js";
import {
  formatFreeTrialDurationText,
  getDiscountOfferText,
  getPromotionRemainingText
} from "../../../shared/utils/paymentUtil.js";

// Actions
import { fetchPromotion } from "../../../shared/actions/promotionAction";
import UnifiedEditProfileModal from "../../Modals/UnifiedEditProfileModal/index.js";
import { reportError } from "../../../shared/sentry";

const CreatorEditProfile = ({
  className,
  isLogging,
  isOwnProfile,
  userRole,
  creatorInfo,
  // Redux state
  user,
  dispatch
}) => {
  const [editProfileModal, setEditProfileModal] = useState(false);
  const [profileType, setProfileType] = useState(null);
  const [promotionData, setPromotionData] = useState(null);

  // const price = parseFloat(creatorInfo?.user_subsData?.price || 0).toFixed(2);
  const real_price = parseFloat(creatorInfo?.user_subsData?.real_price || 0).toFixed(2);
  // Calculate discounted price based on promotion data
  const discountedPrice = promotionData?.discount?.value && promotionData?.discount?.value > 0
    ? (parseFloat(real_price) - (parseFloat(real_price) * promotionData.discount.value / 100)).toFixed(2)
    : real_price;

  useEffect(() => {
    const profileTypeValue = getProfileTypeFromRole(userRole);
    setProfileType(profileTypeValue);
  }, [userRole]);

  const handleEditProfileClick = useCallback(() => {
    const modalType = profileType;
    if (modalType) {
      setEditProfileModal(true);
    }
  }, [profileType]);

  // Fetch promotion data function
  const fetchPromotionData = useCallback(async () => {
    if (!creatorInfo?._id) return;

    try {
      const result = await dispatch(fetchPromotion(creatorInfo._id));

      if (result.success) {
        if (result?.data?._id) {
          setPromotionData(result?.data);
        } else {
          // If no promotion data, set to null
          setPromotionData(null);
        }
      }
    } catch (error) {
      reportError(error, 'CreatorEditProfile fetch promotion');
    }
  }, [creatorInfo?._id, dispatch]);


  useEffect(() => {
    if (editProfileModal) {
      document.body.classList.add('no_body_scroll')
    } else {
      document.body.classList.remove('no_body_scroll')
    }
  }, [editProfileModal])

  // Fetch promotion data on mount and when creatorInfo._id changes
  useEffect(() => {
    fetchPromotionData();
  }, [fetchPromotionData]);

  const promotionText = useMemo(
    () => getDiscountOfferText(promotionData),
    [promotionData]
  );
  const promotionRemainingText = useMemo(
    () => getPromotionRemainingText(promotionData),
    [promotionData]
  );

  if (!isLogging || !isOwnProfile) {
    return null;
  }

  return (
    <div className={className}>
      {userRole === ROLE.CREATOR_SUB &&
        promotionText && promotionRemainingText && promotionRemainingText.isValid && (
          <div className="profile-type-section">
            <span className="profile-type-text">
              {promotionText}{' '}
              {promotionRemainingText.text && '•'}{' '}
              {promotionRemainingText.text}
            </span>
          </div>
        )}

      <div className="profile-actions-section align-items-baseline">
        <div className="profile-stats">
          <div className="stat-item hover-scale cursor-pointer group">
            <i className="fa-solid fa-eye stat-icon"></i>
            <span className="stat-text">
              {nFormatter(creatorInfo?.weeklyViews || 0, 1)}
            </span>
          </div>
        </div>
        <div className="d-flex flex-column items-center">
          <button className="edit-profile-btn" onClick={handleEditProfileClick}>Edit Profile</button>
          {/* Creator Monthly Subscriber Price Section */}
          {userRole === ROLE.CREATOR_SUB ?
            (promotionData?._id ? (
              <div className="profile-price-section">
                <span className="profile-price-text">
                  {promotionData?.offer_type === OFFER_TYPE.FREE_TRIAL ?
                    <>
                      <span className="profile-price-text-free-trial">
                        {formatFreeTrialDurationText(promotionData?.free_trial_duration_days)}
                      </span>
                      <span className="profile-price-text-real">
                        ${real_price}
                      </span>
                    </>
                    :
                    <>
                      {promotionData?.discount?.type === PROMOTION_DISCOUNT_TYPE.PERCENT && promotionData?.discount?.value > 0 ?
                        <>
                          <span className="profile-price">${discountedPrice}</span>
                          <span className="profile-price-text-real">(${real_price}/mo)</span>
                        </>
                        :
                        <span className="profile-price">${real_price}/mo</span>
                      }
                    </>
                  }
                </span>
              </div>
            ) : (
              <div className="profile-price-section">
                <span className="profile-price-text">${real_price}/mo</span>
              </div>
            )) : null}
        </div>

      </div>



      {/* Unified Edit Profile Modal */}
      <UnifiedEditProfileModal
        isOpen={editProfileModal}
        onClose={() => setEditProfileModal(false)}
        userRole={userRole}
        creatorInfo={creatorInfo}
        promotionData={promotionData}
        onSave={(updatedData) => {
          // Handle save logic here if needed
          setEditProfileModal(false);
        }}
        onPromotionChange={fetchPromotionData}
      />
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
    user: state.user?.user,
  };
};


export default connect(mapStateToProps)(CreatorEditProfile);

